import { schemaBitcoinGetXPub } from "@ledgerhq/wallet-api-core";
export class BitcoinModule {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     *
     * @param accountId id of the bitcoin account
     * @returns the xpub of the account
     *
     * @throws {@link ServerError} if an error occured on server side
     */
    async getXPub(accountId) {
        const getXPupResult = await this.client.request("bitcoin.getXPub", {
            accountId,
        });
        const safeResults = schemaBitcoinGetXPub.result.parse(getXPupResult);
        return safeResults.xPub;
    }
}
//# sourceMappingURL=Bitcoin.js.map